module.exports = __webpack_public_path__ + "img/开始排重.fcbf27a8.svg";